import { Grid, Theme, Typography, useMediaQuery } from '@quillbot/design-system';
import React from 'react';
import CitationDeleteAllIcon from './CitationDeleteAllIcon';
import CitationSearchIcon from './CitationSearchIcon';
import CitationListContainer from './CitationList';
import { useCitationGeneratorState } from '../context';
import { getCgBreakpointDown } from '../utils';

type RequiredClasses = 'topBar' | 'topHeading' | 'pane' | 'hideOnSmallScreens';
interface Props {
  classes: { [key in RequiredClasses]: string };
}

const CitationListSection = (props: Props) => {
  const classes = props.classes;
  const isSearchMode = useCitationGeneratorState((state) => state.isSearchMode);
  const isEditMode = useCitationGeneratorState((state) => state.isEditFormOpen);
  const isSmallScreen = useMediaQuery<Theme>((theme) => getCgBreakpointDown(theme));

  return (
    <>
      <Grid
        container
        className={classes.topBar}
        alignItems="center"
        justifyContent="space-between"
        style={{
          display: isSmallScreen && (isSearchMode || isEditMode) ? 'none' : 'flex',
        }}
      >
        <Typography className={`${classes.topHeading} ${classes.pane}`} style={{ marginBottom: 0 }}>
          Citation List
        </Typography>

        <Grid
          alignItems="center"
          style={{ display: 'flex' }}
          className={classes.hideOnSmallScreens}
        >
          <CitationSearchIcon />

          <CitationDeleteAllIcon />
        </Grid>
      </Grid>

      {(isSmallScreen ? !(isSearchMode || isEditMode) : true) && (
        <CitationListContainer cowriterToolbarAction={false} />
      )}
    </>
  );
};

export default CitationListSection;
